import { render, staticRenderFns } from "./PatDossierList.vue?vue&type=template&id=5262384e&scoped=true"
import script from "./PatDossierList.vue?vue&type=script&lang=js"
export * from "./PatDossierList.vue?vue&type=script&lang=js"
import style0 from "./PatDossierList.vue?vue&type=style&index=0&id=5262384e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5262384e",
  null
  
)

export default component.exports